import React from 'react'
import { Login } from 'react-admin'
import withStyles from '@material-ui/core/styles/withStyles'
import LoginForm from './LoginForm'

const styles = {
    login: {
        main: {
            backgroundImage: 'url(/login_bg.jpg) !important',
        },
        card: {
            padding: '5px 0 15px 0',
            '& > div' : {
                display : 'none'
            }
        },
    },
    form: {
        button: {
            height: '3em',
        },
    },
};

const CustomLoginForm = withStyles(styles.form)(LoginForm);

const LoginPage = (props) => (
    <Login loginForm={<CustomLoginForm />} {...props} />
);

export default withStyles(styles.login)(LoginPage);